/**
 * De maatlijn onder de paginatitel, zoals op een bouwtekening en in de Gate
 * Review-applicatie: een lijn met twee pijlpunten en twee eindstreepjes. Hij tekent
 * zich bij het openen van links naar rechts (basis.css, `hs-maatlijn`).
 */
export function Maatlijn() {
  return (
    <svg className="hs-maatlijn" viewBox="0 0 224 12" aria-hidden>
      <line x1="0.5" y1="0" x2="0.5" y2="12" stroke="currentColor" />
      <line className="hs-maatlijn__lijn" x1="0" y1="6" x2="224" y2="6" stroke="currentColor" strokeWidth="1.5" />
      <line x1="223.5" y1="0" x2="223.5" y2="12" stroke="currentColor" />
      <path d="M0 6 L8 3 L8 9 Z" fill="currentColor" />
      <path d="M224 6 L216 3 L216 9 Z" fill="currentColor" />
    </svg>
  );
}
